import React, { useState, useEffect, useRef } from 'react';
import { supabaseClient } from '../../services/supabase';
import { useScrollFadeIn } from '../../utils/scrollFadeIn';

// デフォルトのメニュー（データベースにデータがない場合のフォールバック）
const defaultMenus = {
  food: { title: 'お食事メニュー', image_url: '/images/menu_food.jpg' },
  drink: { title: 'ドリンクメニュー', image_url: '/images/menu_drink.jpg' }
};

function Menu() {
  const sectionRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [menus, setMenus] = useState({ food: null, drink: null });
  const [loading, setLoading] = useState(true);

  // データベースからメニューを取得
  useEffect(() => {
    const loadMenus = async () => {
      try {
        const { data, error } = await supabaseClient
          .from('menu_images')
          .select('*')
          .eq('is_visible', true)
          .order('menu_type', { ascending: true });

        if (error) throw error;

        if (data && data.length > 0) {
          const menuData = { food: null, drink: null };
          data.forEach(item => {
            if (item.menu_type === 'food' && !menuData.food) {
              menuData.food = item;
            } else if (item.menu_type === 'drink' && !menuData.drink) {
              menuData.drink = item;
            }
          });
          setMenus({
            food: menuData.food || defaultMenus.food,
            drink: menuData.drink || defaultMenus.drink
          });
        } else {
          setMenus(defaultMenus);
        }
      } catch (error) {
        console.error('メニュー読み込みエラー:', error);
        setMenus(defaultMenus);
      } finally {
        setLoading(false);
      }
    };

    loadMenus();
  }, []);

  useScrollFadeIn(sectionRef, '.menu-section', [loading]);

  const openModal = (imageSrc, alt) => {
    setSelectedImage({ src: imageSrc, alt });
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };

    if (selectedImage) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [selectedImage]);

  if (loading) {
    return (
      <section id="menu" className="menu" ref={sectionRef}>
        <div className="container">
          <h2 className="section-title">メニュー</h2>
          <p style={{ textAlign: 'center' }}>読み込み中...</p>
        </div>
      </section>
    );
  }

  return (
    <section id="menu" className="menu" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">メニュー</h2>
        
        <div className="menu-grid">
          {menus.food && (
            <div className="menu-section fade-in">
              <h3>◆{menus.food.title || 'お食事'}</h3>
              <div className="menu-image" onClick={() => openModal(menus.food.image_url, menus.food.title || 'お食事')}>
                <img src={menus.food.image_url} alt={menus.food.title || 'お食事'} />
                <div className="menu-image-overlay"></div>
              </div>
            </div>
          )}
          
          {menus.drink && (
            <div className="menu-section fade-in">
              <h3>◆{menus.drink.title || 'ドリンク'}</h3>
              <div className="menu-image" onClick={() => openModal(menus.drink.image_url, menus.drink.title || 'ドリンク')}>
                <img src={menus.drink.image_url} alt={menus.drink.title || 'ドリンク'} />
                <div className="menu-image-overlay"></div>
              </div>
            </div>
          )}
        </div>
      </div>

      {selectedImage && (
        <div className="menu-modal" onClick={closeModal}>
          <div className="menu-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="menu-modal-close" onClick={closeModal}>×</button>
            <img src={selectedImage.src} alt={selectedImage.alt} />
          </div>
        </div>
      )}
    </section>
  );
}

export default Menu;
